import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

import { CommonBaseComponent } from '../common-base.component';

@Component({
  selector: 'app-buttonset',
  templateUrl: './buttonset.component.html',
  styleUrls: ['./buttonset.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
  ],
})
export class ButtonSetComponent extends CommonBaseComponent {
  @Input() defaultValue: any;

  constructor() {
    super();
  }

  get controlItem() {
    return this.form.controls[this.item.key];
  }

  isSelected(option: any) {
    return this.form.controls[this.item.key].value === option.value;
  }
}
